import React from 'react';
import { connect } from 'react-redux';
import { login } from 'redux-implicit-oauth2';
import { Redirect } from 'react-router-dom';
import { Banner, Blockquote, Box, Button, Pre } from 'rebass';
import { blue } from '../colours';
import config from '../auth.config';
import Header from '../Header';

export function Home({ isLoggedIn, handleLogin }) {
  return isLoggedIn ? (
    <Redirect to="/dashboard" />
  ) : (
    <Banner style={{ minHeight: '100vh' }}>
      <Header>
        <Button onClick={handleLogin} fontSize={[4, 6]} bg={blue}>
          Login
        </Button>
      </Header>
      <Box w={[9 / 10, 3 / 4, 1 / 2]} mx="auto" my={4}>
        <Blockquote>
          This is a directory of brands (CPGs) and suppliers (generally
          co-packers), to help provide visibility into which brands are served
          by which suppliers and vice versa.
          <br />
          <br />
          You must use your <Pre style={{ display: 'inline' }}>
            @nulogy.com
          </Pre>{' '}
          email address, and your session will expire in 1 hour.
        </Blockquote>
      </Box>
    </Banner>
  );
}

function mapStateToProps({ auth }) {
  return {
    isLoggedIn: auth.isLoggedIn,
  };
}

const mapDispatchToProps = {
  handleLogin: () => login(config),
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/Home/index.js